module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-1366x1024.421410a3.jpg";